export default class CdnImage {
  public static url(path: string, size: number): string {
    const baseUrl = window.Config['solar_cdn_base_url'];
    const relativeUrl = new URL(path).pathname;

    return (baseUrl === undefined) ? path : `${baseUrl}/cdn/resize/${size}${relativeUrl}`;
  }
}
